import React from 'react';
import { Card, Table } from 'react-bootstrap';
import dateformat from 'utils/dateformat';
import { useAppTheme } from '../../../../contexts/ThemeContext';
import {
  getTableHeaderClass,
  getModernDataTableClass,
  getModernCardHeaderClass,
  getModernCardBodyClass,
  getModernTableClass,
} from 'utils/tableTheme';

const Results = ({ data }) => {
  const currentTheme = useAppTheme();

  const renderTable = (headers, row) => (
    <Table
      style={{ fontSize: '0.9rem' }}
      hover
      responsive
      size="sm"
      className={getModernTableClass(currentTheme)}
    >
      <thead>
        <tr className={getTableHeaderClass(currentTheme)}>
          {headers.map((header) => (
            <th key={header} className="col-sm-2 text-center">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{row}</tbody>
    </Table>
  );

  return (
    <div>
      <Card className={getModernDataTableClass(currentTheme)}>
        <Card.Header className={getModernCardHeaderClass(currentTheme)}>
          <h5 className="mt-2 mb-2">Ativações</h5>
        </Card.Header>
        <Card.Body className={getModernCardBodyClass(currentTheme)}>
          {data && data.map((item) => (
            <div key={item._id || ''} className="mb-4">
              {renderTable(
                ['SERIAL', 'DATA', 'NOME', 'E-MAIL', 'SOFTWARE'],
                (
                  <tr>
                    <td className="text-center pt-2 pb-2">{item.serialnumber || item.sn || '--'}</td>
                    <td className="text-center pt-2 pb-2">{item.updatedAt ? dateformat(item.updatedAt) : '--'}</td>
                    <td className="text-center pt-2 pb-2">{item.name || '--'}</td>
                    <td className="text-center pt-2 pb-2">{item.email || '--'}</td>
                    <td className="text-center pt-2 pb-2">{item.versaosw || '--'}</td>
                  </tr>
                )
              )}

              {renderTable(
                ['ID DO COPO', 'AÇÃO', 'LATITUDE', 'LONGITUDE', 'ENDEREÇO'],
                (
                  <tr>
                    <td className="text-center pt-2 pb-2">{item.id || item.cupid || '--'}</td>
                    <td className="text-center pt-2 pb-2">{item.action || '--'}</td>
                    <td className="text-center pt-2 pb-2">
                      {item.lat ? (
                        <a
                          href={`https://www.google.com/maps?q=${item.lat},${item.lng || 0}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#007bff', textDecoration: 'none' }}
                        >
                          {item.lat}
                        </a>
                      ) : '--'}
                    </td>
                    <td className="text-center pt-2 pb-2">
                      {item.lng ? (
                        <a
                          href={`https://www.google.com/maps?q=${item.lat || 0},${item.lng}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#007bff', textDecoration: 'none' }}
                        >
                          {item.lng}
                        </a>
                      ) : '--'}
                    </td>
                    <td className="text-center pt-2 pb-2">{item.address || '--'}</td>
                  </tr>
                )
              )}
            </div>
          ))}
        </Card.Body>
      </Card>
    </div>
  );
};

export default Results;
